import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {selectIsSingle} from '../../../selectors';

@customElement('visual-housing')
export class VisualHousing extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
	  }
	`;

	@property({type: Object})
	section = {};

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
	}

	render() {
		return html`
			${when(selectIsSingle(this.state),
				() => html`
					<svg-productimage-single></svg-productimage-single>`,
				() => html`
					<svg-productimage></svg-productimage>
            `)}
			<svg-housingcolour></svg-housingcolour>
		`;
	}
}
